export default __webpack_public_path__ + "e42f1adcf2e5b1b09e31a8251226ad70.svg";